import iamAPI from "../../api/iamAPI";
import { urlContexts } from "../../constants";

export const getRefreshToken = async (token: string) => {
  const { data } = await iamAPI.get(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/auth/refreshToken`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  );

  return data;
};